import { useState } from "react";
import { useEffect } from "react";
import UserManagementActions from "../../Actions/UserManagementActions";
import UsermanagementConstants from "../../Constants/UsermanagementConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import commonUtils from "../../helpers/commonUtils";
import useForm from "../../helpers/formValidations";
import usermanagementStore from "../../Stores/UsermanagementStore";
import AppConstants from "../../Constants/AppConstants";

const Addnewuser = (props) => {
  const { userDetails } = props;
  const [userid, setUserId] = useState(AppConstants.DEFAULT_GUID);
  const [firstName, setFirstName] = useState("");
  const [surname, setSurname] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [plantId, setPlantId] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [extern, setExtern] = useState("true");
  const [Aktiv, setAktiv] = useState(true);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { handleChange, values, errors, handleSubmit, handleReset } = useForm();

  const getPlants = (id) => {
    UserManagementActions.getPlantsByUserId();
  };

  useEffect(() => {
    setUserId(userDetails.id ? userDetails.id : AppConstants.DEFAULT_GUID);
    setFirstName(userDetails.vorname ? userDetails.vorname : "");
    setSurname(userDetails.nachname ? userDetails.nachname : "");
    setUsername(userDetails.username ? userDetails.username : "");
    setEmail(userDetails.email ? userDetails.email : "");
    setPhone(userDetails.personalNr ? userDetails.personalNr : "");
    setExtern(userDetails.isExtern ? "true" : "false");
    setPlantId(userDetails.werkID ? userDetails.werkID : "");
    setAktiv(userDetails ? userDetails.aktiv : true);
  }, [props]);

  useEffect(() => {
    getPlants(sessionStorage.getItem("userid"));

    function getPlantSuccess() {
      var res = usermanagementStore.getPlantResult();
      if (res.length > 0) {
        setPlantList(res);
      } else {
        setPlantList([]);
      }
    }

    function getPlantFailure() {}

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_SUCCESS,
      getPlantSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_FAILURE,
      getPlantFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_SUCCESS,
        getPlantSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_FAILURE,
        getPlantFailure,
      );
    };
  }, []);

  const userAdd = (e) => {
    e.preventDefault();
    if (Object.keys(errors).length === 0) {
      const user = {
        ID: userid,
        Vorname: firstName.trim(),
        Nachname: surname.trim(),
        Username: username.trim(),
        Email: email,
        PersonalNr: phone,
        WerkID: plantId,
        IsExtern: extern,
        Aktiv: Aktiv,
      };
      setGlobalSpinner(true);
      userid != AppConstants.DEFAULT_GUID
        ? commonUtils.setIsEdit(true)
        : commonUtils.setIsEdit(false);
      UserManagementActions.addOrUpdateUser(user);
    } else {
      return;
    }
  };
  const handlePopOverClose = () => {
    if (userid === AppConstants.DEFAULT_GUID) {
      setFirstName("");
      setSurname("");
      setUsername("");
      setEmail("");
      setPhone("");
      setExtern("false");
      setPlantId("");
      setAktiv(true);
      handleReset();
    }
  };
  return (
    <div
      className="modal fade"
      id="addNewUser"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addNewUser"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog custom-modal-medium" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addNewUser">
              {userDetails ? localization.editUser : localization.addNewUser}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addNewUserModalClose"
              onClick={handlePopOverClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form id="userAdd" name="userAdd" onSubmit={userAdd}>
            <div className="modal-body">
              <div className="row mb-4">
                <div className="col">
                  <div className="form-outline mb-4">
                    <label className="form-label" htmlFor="firstname">
                      {localization.firstName}
                    </label>
                    <input
                      type="text"
                      id="firstname"
                      name="firstname"
                      required
                      className="form-control"
                      placeholder={localization.firstName}
                      value={firstName}
                      onChange={(e) => {
                        e.preventDefault();
                        if (firstName !== "") {
                          setFirstName(e.target.value);
                        } else {
                          setFirstName(e.target.value.trim());
                        }
                      }}
                    />
                  </div>
                  <div className="form-outline mb-4">
                    <label className="form-label" htmlFor="surname">
                      {localization.surname}
                    </label>
                    <input
                      type="text"
                      id="surname"
                      name="surname"
                      className="form-control"
                      required
                      placeholder={localization.surname}
                      value={surname}
                      onChange={(e) => {
                        e.preventDefault();
                        if (surname !== "") {
                          setSurname(e.target.value);
                        } else {
                          setSurname(e.target.value.trim());
                        }
                      }}
                    />
                  </div>
                  <div className="form-outline mb-4">
                    <label className="form-label" htmlFor="username">
                      {localization.username}
                    </label>
                    <input
                      type="text"
                      id="username"
                      name="username"
                      className="form-control"
                      required
                      placeholder={localization.username}
                      disabled={userDetails}
                      value={username}
                      maxLength={150}
                      onChange={(e) => {
                        e.preventDefault();
                        if (username !== "") {
                          setUsername(e.target.value);
                        } else {
                          setUsername(e.target.value.trim());
                        }
                      }}
                    />
                  </div>

                  <div className="form-outline mb-4">
                    <label className="form-label" htmlFor="email">
                      {localization.email}
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      required
                      placeholder="example@gmail.com"
                      value={email}
                      maxLength={64}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-outline mb-4">
                    <label className="form-label" htmlFor="phone">
                      {localization.personalNr}
                    </label>
                    <input
                      type="number"
                      id="personalNr"
                      name="personalNr"
                      className="form-control"
                      placeholder="12345678"
                      value={phone}
                      maxLength={8}
                      onChange={(e) => {
                        setPhone(e.target.value);
                      }}
                      onBlur={(e) => {
                        handleChange(e);
                      }}
                    />
                    {errors.personalNr && (
                      <p className="errorCls">{errors.personalNr}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="plantList">{localization.plant}</label>
                    <select
                      className="form-control"
                      id="plantList"
                      name="plantList"
                      required
                      value={plantId}
                      onChange={(e) => {
                        setPlantId(e.target.value);
                      }}
                    >
                      <option value="">{localization.selectPlant}</option>
                      {plantList.map((row, index) => {
                        return (
                          <option key={index} value={row.id}>
                            {row.bezeichnung}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="extern">{localization.extern}</label>
                    <select
                      className="form-control"
                      id="extern"
                      name="extern"
                      value={extern}
                      onChange={(e) => {
                        setExtern(e.target.value);
                      }}
                    >
                      <option value="true">{localization.yes}</option>
                      <option value="false">{localization.no}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group marProp">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4 saveBtnCls"
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Addnewuser;
